import _implicitStylesheets from "./moreFromThisProvider.css";
import _implicitScopedStylesheets from "./moreFromThisProvider.scoped.css?scoped=true";
import _wdsTilesGrid from "wds/tilesGrid";
import {freezeTemplate, registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element} = $api;
  return [$cmp.displayMoreFromThisProvider ? api_custom_element("wds-tiles-grid", _wdsTilesGrid, {
    props: {
      "gridItemSize": "1:1 1:4@large",
      "gridGap": "x-large",
      "gridAlignItems": "flex-start",
      "gridAxis": "row",
      "gridFlow": "wrap",
      "gridRowGap": "x-large",
      "props": $cmp.props,
      "records": $cmp.providerListings
    },
    key: 0
  }) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7ajpqtl8k05";
tmpl.legacyStylesheetToken = "undefined-_moreFromThisProvider";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
